import { groupAccountMapEntityName } from '../../../../backend/features/groups/shared/entities';
import { toKebabCase } from '../../../../utils/toKebabCase';
/**
 * Get Audit Tag value from Account Section
 *
 * auditTags are part of Entity Audit feature (platform) to add custom tags for entity updates
 */
export function mapAccountSectionToAuditTag(section) {
    if (section.key === 'groups') {
        return toKebabCase(groupAccountMapEntityName).replace(/-+/g, '-');
    }
    return toKebabCase(section.name).replace(/-+/g, '-');
}
